module.exports = __webpack_public_path__ + "files/673b0c7e65c39f6e5f9d4ca726f83cc3.png";